export const IMPORT_STAGE = Object.freeze({
  EXTRACTING: "extracting",
  MATCHING: "matching",
  AWAITING_DECISIONS: "awaiting_decisions",
  COMPLETED: "completed",
  FAILED: "failed",
  EXPIRED: "expired",
  CANCELLED: "cancelled",
});

export const IMPORT_OUTCOME_NOTHING_FOUND = "nothing_found";

export const DECISION_ACTION = Object.freeze({
  ATTACH_DIRECT: "attach_direct",
  ATTACH_VIA_ROLE: "attach_via_role",
  CREATE_NEW: "create_new",
  SKIP: "skip",
  LEAVE_AS_IS: "leave_as_is",
});

const DECISION_PENDING = "pending";

const DECISION_LABELS = Object.freeze({
  attached: "Attach matched responsibility directly to position",
  created: "Create and attach new responsibility",
  skipped: "Discard proposal and move to next",
  left_as_is: "Leave as is, it is already on the position",
});

export const DONE_TEXT =
  "All found responsibilities where processed. You can now close this window.";
export const NOTHING_FOUND_TEXT =
  "The file you imported contains no job description information. Upload a file that contains a job description";
export const FAILED_TEXT = "Something went wrong while reading the file.";
export const EXPIRED_TEXT =
  "This import expired before it was finished. Upload the job description again to start a new import.";
export const NO_IMPORT_TEXT = "There is no import in progress for this position.";

export const DECISION_ERROR_TEXT = "We could not save this decision. Please try again.";
export const REFRESHED_TEXT = "This import changed in the meantime. Showing the latest state.";
export const COVERAGE_CHANGED_TEXT =
  "This responsibility was attached to the position in the meantime. Choose again.";
export const LOAD_ERROR_TEXT = "We could not load this import. Please try again.";
export const ACTION_ERROR_TEXT = "That did not work. Please try again.";

export function buildIntroText(total, fileName = "") {
  const noun = total === 1 ? "responsibility" : "responsibilities";
  const source = fileName ? ` in ${fileName}` : "";
  return `IQ found ${total} ${noun}${source}. Let's go through them one by one.`;
}

export function isProcessingStage(stage) {
  return stage === IMPORT_STAGE.EXTRACTING || stage === IMPORT_STAGE.MATCHING;
}

export function isPendingItem(item) {
  return !item || item.decision === DECISION_PENDING;
}

export function decisionLabel(item) {
  return DECISION_LABELS[item?.decision] || "";
}

function responsibilityIdentity(responsibility) {
  if (!responsibility) return "";
  return [responsibility.code, responsibility.name].filter(Boolean).join(" - ");
}

function coverageSentence(item) {
  const identity = responsibilityIdentity(item.matched_responsibility);
  const coverage = item.coverage || {};
  if (coverage.type === "direct") {
    return `${identity} is already attached to this position directly.`;
  }
  if (coverage.type === "via_role") {
    const role = [coverage.role?.code, coverage.role?.name].filter(Boolean).join(" - ");
    return role
      ? `${identity} is already attached to this position via the role ${role}.`
      : `${identity} is already attached to this position via an attached Role.`;
  }
  return `This looks like the catalog responsibility ${identity}.`;
}

export function buildItemMessage(item, total) {
  const prefix = `(${item.index}/${total})`;
  const quote = `"${item.text}"`;
  if (!item.matched_responsibility) {
    return `${prefix} ${quote} does not match any existing responsibility in the catalog`;
  }
  return `${prefix} ${quote}\n\n${coverageSentence(item)}`;
}

export function firstUndecidedIndex(items) {
  return items.findIndex(isPendingItem);
}

export function replaceItem(items, updated) {
  if (!updated) return items;
  return items.map((item) => (item.id === updated.id ? updated : item));
}

export function importErrorCode(error) {
  return error?.response?.data?.code || "";
}

export function importErrorItem(error) {
  return error?.response?.data?.details?.item || null;
}
